import { createRouter, createWebHistory } from 'vue-router';
import AuthView from '../views/AuthView.vue';
import DashboardView from '../views/DashboardView.vue';
import { useAuthStore } from '../stores/auth';

const routes = [
  {
    path: '/login',
    name: 'auth',
    component: AuthView,
    meta: {
      requiresGuest: true,
      title: 'Sign in | New Order Clean',
      description: 'Access your New Order Clean account to manage catalogs, journals, and invoices.',
    },
  },
  {
    path: '/',
    name: 'dashboard',
    component: DashboardView,
    meta: {
      requiresAuth: true,
      title: 'Dashboard | New Order Clean',
      description:
        'Manage catalogs, appointments, purchases, and client invoices within New Order Clean.',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore();
  if (!auth.initialized) {
    await auth.initialize();
  }

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return next({ name: 'auth' });
  }

  if (to.meta.requiresGuest && auth.isAuthenticated) {
    return next({ name: 'dashboard' });
  }

  return next();
});

const DEFAULT_TITLE = 'New Order Clean';
const DEFAULT_DESCRIPTION =
  'New Order Clean workspace for managing catalogs, journals, and client invoices.';

router.afterEach((to) => {
  const meta = to?.meta || {};
  const title = typeof meta.title === 'function' ? meta.title(to) : meta.title;
  const description =
    typeof meta.description === 'function' ? meta.description(to) : meta.description;
  document.title = title || DEFAULT_TITLE;
  if (description && document) {
    const tag =
      document.querySelector('meta[name=\"description\"]') ||
      (() => {
        const el = document.createElement('meta');
        el.setAttribute('name', 'description');
        document.head.appendChild(el);
        return el;
      })();
    tag.setAttribute('content', description || DEFAULT_DESCRIPTION);
  }
});

export default router;
